import { render, staticRenderFns } from "./PopupUpdateTransformStatus.vue?vue&type=template&id=46753791&scoped=true"
import script from "./PopupUpdateTransformStatus.vue?vue&type=script&lang=js"
export * from "./PopupUpdateTransformStatus.vue?vue&type=script&lang=js"
import style0 from "./PopupUpdateTransformStatus.vue?vue&type=style&index=0&id=46753791&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46753791",
  null
  
)

export default component.exports